import React from 'react';
import {Button} from 'reactstrap';

const ShowMorePackagesButton = (props) => {
  return (
    <Button color='link' type='button' className={`${props.customeClass || ''} show-more-packages-button`} onClick={props.onClick}>
      <span className='button-text'>{props.title}</span>
      <span className='plus-icon'>+</span>
    </Button>
  );
};

export default ShowMorePackagesButton;
